// extracted by mini-css-extract-plugin
export default {"heatedLivingAreaAlert":"FirstSection_heatedLivingAreaAlert__fqmor"};